// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

import { createApp } from 'vue';
import store from './store';
import { actionTypes as geoActions } from './store/geolocation';
import router from './router';
import i18n, { loadDefaultLanguageAsync } from './i18n';
import componentLibrary from '@protolabs/component-library';

import App from './App.vue';
import analytics from '@/utils/analytics';

async function init() {
    const params = new URLSearchParams(document.location.search);
    const marketingLanguage = params.get('lang');
    const languageOverride = marketingLanguage || null;
    try {
        await Promise.all([
            store.dispatch(geoActions.LOAD_COUNTRIES),
            store.dispatch(geoActions.LOAD_LINKED_GROUPS),
            loadDefaultLanguageAsync(languageOverride),
        ]);
        analytics.identify();
    } catch (error) {
        console.error(error);
    }
}

init().then(() => {
    createApp(App)
        .use(i18n)
        .use(componentLibrary, {
            theme: 'protolabs-2023'
        })
        .use(store)
        .use(router)
        .mount('#app');
});
